import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomPackagesComponent } from "../custom-packages.component";

const routes: Routes = [{ path: "", redirectTo: "custom-packages", pathMatch: 'full' }, { path: "custom-packages", component: CustomPackagesComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CustomPackagesRoutingModule { }
